import { SET_GENERAL_ERROR, DELETE_GENERAL_ERROR } from "../types";
import {actionTypeGenerator} from "../utils";

export const ERROR = actionTypeGenerator('error');

let initialState = [];

export const error = (state = initialState, action) => {
  switch (action.type) {
    case ERROR.create: return [...state, action.payload];

    case ERROR.delete: return state.filter((item) => item.id !== action.payload);

    default:
      return state;
  }
};


